import { h } from "preact";
import { observer } from "mobx-preact";
import "./index.less";
import { isMobile } from "../../utils/device-utils";

const prefix = isMobile() ? "xfe-common-login-modal-mobile" : "xfe-common-login-theme";

const Theme = (props) => {
  const themeImgs = window?.XPASS?.themeImgs;
  return (
    <div className={`${prefix}-theme`}>
      <div className={`${prefix}-themeBox`}>
        <div className={`${prefix}-themeTop`} style={themeImgs?.top && { backgroundImage: `url(${themeImgs?.top})` }}/>
      </div>
      <div className={`${prefix}-themeBoxContent`}>
        <div className={`${prefix}-themeContent`} style={themeImgs?.middle && { backgroundImage: `url(${themeImgs?.middle})` }}>{props.children}</div>

      </div>
      <div className={`${prefix}-themeBox`}>
        <div className={`${prefix}-themeBottom`} style={themeImgs?.bottom && { backgroundImage: `url(${themeImgs?.bottom})` }}/>
      </div>
    </div>
  );
};

export default observer(Theme);
